module.exports = __webpack_public_path__ + "static/media/file-video.cdcfddea.svg";